	var crrnt_cart;
	var app_fee_prod = false;
    var dip_fee_prod = false;  
    var fees_rr = {};	fees_rr["ossd_fee"] = {};	fees_rr["fee"] = {};
    var cart_has_fee = false;
  	var max_cart_lengt = 8;


	var jquery = window.$;
  
    $.getJSON('/products.json?limit=250', function(data) {
        prdcts_lst = data;
        for (var indx in prdcts_lst.products) {
            if (prdcts_lst.products[indx].product_type == "fee") {
                app_fee_prod = prdcts_lst.products[indx];
            }
            if (prdcts_lst.products[indx].product_type == "ossd_fee") {
                dip_fee_prod = prdcts_lst.products[indx];
            }
        }
        if (!app_fee_prod) {
            throw "APPLICATION FEE-PRODUCT WAS NOT FOUND";
        }
        if (!dip_fee_prod) {
            throw "DIPLOMA FEE-PRODUCT WAS NOT FOUND";
        }
        for (var indx in app_fee_prod.variants) {
            if (app_fee_prod.variants[indx].title == "ON") {
                fees_rr["fee"]["ON"] = app_fee_prod.variants[indx].id;
            }
            if (app_fee_prod.variants[indx].title == "Non-ON") {
                fees_rr["fee"]["Non-ON"] = app_fee_prod.variants[indx].id;
            }
        }
        for (var indx in dip_fee_prod.variants) {
            if (dip_fee_prod.variants[indx].title == "ON") {
                fees_rr["ossd_fee"]["ON"] = dip_fee_prod.variants[indx].id;
            }
            if (dip_fee_prod.variants[indx].title == "Non-ON") {
                fees_rr["ossd_fee"]["Non-ON"] = dip_fee_prod.variants[indx].id;
            }
        }
    }); 


// checks if cart has fee in it
function do_check_cart() {
	console.log("do_check_cart");

	cart_has_fee = false;
	for (var itm of crrnt_cart.items) {

        if (itm.variant_id == fees_rr["ossd_fee"]["ON"]) {
          cart_has_fee = true;
        }
        if (itm.variant_id == fees_rr["ossd_fee"]["Non-ON"]) {
          cart_has_fee = true;
        }
        if (itm.variant_id == fees_rr["fee"]["ON"]) {
          cart_has_fee = true;
        }
        if (itm.variant_id == fees_rr["fee"]["Non-ON"]) {
          cart_has_fee = true;
        }
		
	}
}

window.addEventListener('load', function () {
  
  	$(document).ready(function () {
      
      
      
   
      
    console.log("collection-courses.js.liquid");  

	//onload, disable Add to cart button for items already in the cart on load
    disableMultBuyButton();      

    // Select the node (choose courses results div) that will be observed for mutations
	const targetNode = document.querySelector(".usf-results");      

    if (targetNode !== null) {
      var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

      // Options for the observer (which mutations to observe)
      const config = { childList: true };

      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {

        console.log("mutation occurred, disabling buttons");

        //disable Add to Cart buttons whose course is in the cart
          if (mutationsList.length > 0) {
            disableMultBuyButton();
          }

        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);    

    }
      
    function disableMultBuyButton() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {                 
          cart.items.forEach((obj, i) => { 
            var nextButt = $("input[value='"+ obj.id + "']").closest('form').find('button');
            nextButt.prop('disabled', true);
            nextButt.html('&#x2714; Course added');
          });

        }
      });        
    }      
            

      
      
    window.popup_sets = {
        "p5": {
            "hdr": "Maximum 8 Courses reached.",
            "cntnt": "A maximum of 8 courses can be added per application. Please visit your bag and remove courses to add more. If you need help deciding on what courses to add, please contact us.",
            "bttn": "Go to Bag",
            "url": "/cart",
            "trgt": "",
            "cancel": "do_nothing",
            "ok": "",
        },
        "p6": {
            "hdr": "You have an application fee in your cart.",
            "cntnt": "You can not add courcess to the cart if there is an application fee in it.",
            "bttn": "Empty Cart",
            "url": "",
            "trgt": "",
            "cancel": "do_nothing",
            "ok": "do_empty_cart",
        },
    };	         
      
	$(document).on("click", "#usf-add-to-cart-ajax", function (event) {
          console.log("the button got clicked!");

          var allowPurchase = 1;
          var $previouslyFocusedElement = $(':focus');

          $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            async: false,
            dataType: 'json',
            success: function( cart ) {
              
              crrnt_cart = cart;
              
              do_check_cart();
              
              
              if( cart_has_fee ){
                allowPurchase = 0;
                do_pop_up('p6');              
              
              }
              
              
              if (cart.items.length >= 8) {
                allowPurchase = 0;
                do_pop_up('p5');
                // alert("You can not purchase more than 8 courses.");
              }
            }
          });      
      
	      if (allowPurchase === 1) {

            var target = this;

            if (window.theme.cartType === 'page') {
              return; // When using a cart type of page, we just simply redirect to the cart page
            }
            event.preventDefault(); // Prevent form to be submitted
            event.stopPropagation();

            // First, we switch the status of the button
            target.setAttribute('disabled', 'disabled');
            // document.dispatchEvent(new CustomEvent('theme:loading:start'));

            // Then we add the product in Ajax
            var formElement = target.closest('form[action*="/cart/add"]');

            var params = {
              url: '/cart/add.js',
              data: $(formElement).serialize(),
              dataType: 'json'
            };

            $.post(params)
                  .done( // item added
                    function (item) {
                      $( target ).html('&#x2714; Course added');
                      console.log(item);localStorage.removeItem("crrnt_stp");
                        localStorage.removeItem("last_step");
                        localStorage.removeItem("form-personal-info");//add dialog listeners
                      _setupCartPopupEventListeners();

                      //set values in Dialog
                      
                      /// EKH BUG #82793
                      var crt_prdct_str = item.product_title;
                      var crt_prdct_rrr = crt_prdct_str.split(": ");
                      var tmp_rr = [];
                      if( crt_prdct_rrr.length > 2){
                       		tmp_rr[0] = crt_prdct_rrr[0];
                        	crt_prdct_rrr.splice(0, 1);
                        	tmp_rr[1] = crt_prdct_rrr.join(': ');
                        	crt_prdct_rrr = tmp_rr;
                      }
                      
                      
                      if( crt_prdct_rrr.length == 2){
                      		$("[data-cart-popup-title]").text(crt_prdct_rrr[1]+" (" + crt_prdct_rrr[0].substr(0,5) + ")");
    				  }	

                      
                      

                      $("[data-cart-popup-quantity]").text(item.quantity); //this is the item quantity
                      $("[data-cart-popup-quantity-label]").text(theme.strings.quantityLabel.replace('[count]', item.quantity));

                      //deal with image
                      _setCartPopupPlaceholder (item.imageUrl, item.imageAspectRatio);                          
                      _setCartPopupImage(item.featured_image.url, item.featured_image.alt);
                      _setCartPopupProductDetails(
                          item.product_has_only_default_variant,
                          item.options_with_values,
                          item.properties
                      );

                      $.getJSON('/cart.js').then(
                        function(cart) {
                          _setCartQuantity(cart.item_count);
                          _setCartCountBubble(cart.item_count);
                          _showCartPopup();
                        }.bind(this)
                      );                          

                      //Display dialog
                      $(".cart-popup-wrapper").removeClass('cart-popup-wrapper--hidden').addClass('cart-popup-wrapper--visible');
                       
                    }.bind(this)
                  ).fail(() => {
	                  // Display error here
                  })

            event.preventDefault();
          } else {
              event.preventDefault(); // Prevent form to be submitted
              event.stopPropagation();
          }
      
      function _setupCartPopupEventListeners() {
        $('[data-cart-popup-wrapper]').on(
          'keyup',
          function(event) {
            if (event.keyCode === 27) { 	//27 = ESCAPE
              _hideCartPopup(event);
            }
          }.bind(this)
        );                  
        $('[data-cart-popup-close]').on('click', _hideCartPopup.bind(this));
        $('[data-cart-popup-dismiss]').on('click', _hideCartPopup.bind(this));
        $('body').on('click', _onBodyClick.bind(this));
      }

      function _hideCartPopup (event) {
          var setFocus = event.detail === 0 ? true : false;
          $('[data-cart-popup-wrapper]').prepareTransition().addClass('cart-popup-wrapper--hidden');

          $('[data-cart-popup-image]').remove();
          $('[data-cart-popup-image-placeholder]').removeClass('hide');

          removeTrapFocus({
                            $container: '[data-cart-popup-wrapper]',
                            namespace: 'cartPopupFocus'
                          });

          if (setFocus) $previouslyFocusedElement.focus(); 

          $('[data-cart-popup-wrapper]').off('keyup');
          $('[data-cart-popup-close]').off('click');
          $('[data-cart-popup-dismiss]').off('click');
          $('body').off('click');
      }            

      function _setCartPopupPlaceholder (imageUrl, imageAspectRatio) {
        if (imageUrl === null) {
          $("[data-cart-popup-image-wrapper]").addClass('hide');
          return;
        }

        var $placeholder = $("[data-placeholder-size]");
        var maxWidth = 95 * imageAspectRatio;
        var heightRatio = 100 / imageAspectRatio;

        $('[data-cart-popup-image-placeholder]').css('max-width', maxWidth);
        $placeholder.css('padding-top', heightRatio + '%');
      }

      function _setCartPopupImage (imageUrl, imageAlt) {
        $("[data-cart-popup-image]").remove();
        if (imageUrl === null) return;

        $("[data-cart-popup-image-wrapper]").removeClass('hide');
        var sizedImageUrl = getSizedImageUrl(imageUrl, '200x');
        var image = document.createElement('img');
        image.src = sizedImageUrl;
        image.alt = imageAlt;
        image.classList.add('cart-popup-item__image');
        image.dataset.cartPopupImage = '';

        image.onload = function() {
          $('[data-cart-popup-image-placeholder]').addClass('hide');
          $("[data-cart-popup-image-wrapper]").append(image);
        }.bind(this); 
      }

      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return removeProtocol(src);
        }

        var match = src.match(
          /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match !== null) {
          var prefix = src.split(match[0]);
          var suffix = match[0];

          return removeProtocol(prefix[0] + '_' + size + suffix);
        }

        return null;
      }

      function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
      }

      function _setCartPopupProductDetails(product_has_only_default_variant, options, properties) {
      }

      function _setCartQuantity (quantity) {
        var ariaLabel;

        if (quantity === 1) {
          ariaLabel = theme.strings.oneCartCount;
        } else if (quantity > 1) {
          ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
        }

        $('[data-cart-popup-cart-quantity]').text(quantity).attr('aria-label', ariaLabel);

      }

      function _setCartCountBubble (quantity) {
        $('[data-cart-count-bubble]').removeClass('hide');
        $('[data-cart-count]').text(quantity);
      }

      function _showCartPopup () {
        $('[data-cart-popup-wrapper]')
        .prepareTransition()
        .removeClass('cart-popup-wrapper--hidden');
        _handleButtonLoadingState(false);

        trapFocus({
              $container: '[data-cart-popup-wrapper]',
              $elementToFocus: '[data-cart-popup]',
              namespace: 'cartPopupFocus'
            }); 
      }

     function _handleButtonLoadingState (isLoading) {
      if (isLoading) {
        $('[data-add-to-cart]').attr('aria-disabled', true);
        $('[data-add-to-cart-text]').addClass( 'hide');
        $('[data-loader]').removeClass( 'hide');
        $('.shopify-payment-button').attr('disabled', true);
        $('[data-loader-status]').attr('aria-hidden', false);
      } else {
        $('[data-add-to-cart]').removeAttr('aria-disabled');
        $('[data-add-to-cart-text]').removeClass( 'hide');
        $('[data-loader]').addClass( 'hide');
        $('.shopify-payment-button').removeAttr('disabled');
        $('[data-loader-status]').attr('aria-hidden', true);
      }
    }     
      
      
      
      
      
  function trapFocus (options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = $('[data-cart-popup-wrapper]').find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;	//TAB

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      } 
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    } 

    $('[data-cart-popup-wrapper]').attr('tabindex', '-1');
    $('[data-cart-popup]').focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  }      
      
      

      
  	  function removeTrapFocus (options) {
    		var eventName = options.namespace
      			? 'focusin.' + options.namespace
      			: 'focusin';

        console.log(options.$container);
        /* come back to this */
        if (options.$container && options.$container.length) {
          	$("[data-popup-wrapper]").removeAttr("tabIndex");
        }

        $(document).off(eventName);
      }
      
	  function _onBodyClick (event) {
         var $target = $(event.target);
          if (
            $target[0] !== '[data-cart-popup-wrapper]' &&
            !$target.parents('[data-cart-popup]').length
          ) {
            _hideCartPopup(event);
          }        
      }
      
      
      function do_nothing(){}
      window.do_nothing = do_nothing;
      
      // clears crt items
      function do_empty_cart() {
          console.log("do_remove_fees");
          $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              success: function() {
                  localStorage.removeItem("crrnt_stp");
                  localStorage.removeItem("last_step");
                  localStorage.removeItem("form-personal-info");
                  location.reload();
              },
              dataType: 'json'
          });
      }
      
      
      window.do_empty_cart = do_empty_cart;
      
      
    });
  });
  
  
}, false);



    /** Save Personal info form step4 to localstorage logic **/
// Function to save the entire form data as a single object in localStorage
    function saveFormToLocalStorage() {
        const form = document.querySelector('[form-personal-info]');
        const formData = new FormData(form);
        const formObject = {};

        // Convert FormData to an object
        formData.forEach((value, key) => {
            formObject[key] = value;
        });

        // Save the object in localStorage as a JSON string
        localStorage.setItem('form-personal-info', JSON.stringify(formObject));
    }

    // Function to pre-fill the form with data from localStorage
    function prefillForm() {
        const form = document.querySelector('[form-personal-info]');
        if (!form) return null;
        const storedFormData = localStorage.getItem('form-personal-info');

        if (storedFormData) {
            const formObject = JSON.parse(storedFormData);

            // Iterate through form fields and pre-fill with stored data
            for (const [key, value] of Object.entries(formObject)) {
                if (form.elements[key]) {
                    form.elements[key].value = value;
                    if (value) form.elements[key].classList.add('field-has-value');
                }
            }
            const event = new Event('change', { bubbles: true });
            form.dispatchEvent(event);
        }
    }

    // Add event listeners for form changes and submission
    const form = document.querySelector('[form-personal-info]');
    if (form) {
        form.addEventListener('change', saveFormToLocalStorage);
    }

    window.onload = prefillForm;